import './assets/styles/main.scss'

import Vue from 'vue'
import vueDebounce from 'vue-debounce'

import App from './App.vue'
import router from './router'
import api from './plugins/api'

import PdfViewer from './components/PdfViewer.vue'

Vue.config.productionTip = false

Vue.use(api)
Vue.use(vueDebounce)
Vue.component('PdfViewer', PdfViewer)

new Vue({
  render: h => h(App),
  router,
}).$mount('#app')
